import {
    Backdrop,
    Box,
    Grid,
    Grow,
    Modal,
} from '@material-ui/core';
import React, { useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import Switch from "react-switch";
import swal from 'sweetalert2';
import * as Utils from '../../commons/utils/Utils';
import $ from 'jquery';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';

const DisponibilidadActivaExport = (props) => {
    const intl = useIntl();
    const ITEM_XS = 3;
    const [loading, setLoading] = useState(false);
    const [dataToExport, setDataToExport] = useState({
        dominio: true,
        motivo: true,
        fechaInicioOciosidad: true,
        fechaEventoOciosidad: true,
        fechaFinOciosidad: true,
        fecha_actualizacion_motivo: true,
        usuarioModificacionMotivo: true,
        modelo: true,
        tipo: true,
        base: true,
        subRegion: true,
        region: true,
        transportadora: ConfigBusiness.get('moviles.transportadora.grilla') === 'true',
        rentadora: ConfigBusiness.get('frontend.rentadora.grilla') === 'true',
        centroCostos: true,
    });

    const handleDataExport = (column) => {
        setDataToExport((prev) => ({
            ...prev,
            [column]: !prev[column],
        }));
    };

    const handleExportExcel = (event) => {
        event.preventDefault();
        setLoading(true);

        swal.fire({
            title: intl.formatMessage({ id: "azureCallback.information.aguarde_instantes", defaultMessage: "Aguarde unos instantes" }),
            html: intl.formatMessage({ id: "disponibilidadGrid.render.export_modal.columns_export.information_esta_accion_puede_demorar_unos_minutos", defaultMessage: "Esta acción puede demorar unos minutos." }),
            allowOutsideClick: false,
            onBeforeOpen: () => {
                swal.showLoading();
            },
        });

        const auxDataToExport = JSON.stringify({
            colsAExportar: dataToExport,
            queryFilters: props.queryFilters,
        });

        Utils.dataBlob(`/disponibilidad/activa/exportar-excel`, 'POST', auxDataToExport)
            .then((res) => {
                swal.close();
                const fileBlob = new File([res.data], res.filename);
                const fileUrl = URL.createObjectURL(fileBlob);
                $("<a />", {
                    href: fileUrl,
                    download: res.filename.replace(/"/g, ""),
                }).appendTo("body").get(0).click();
            }).catch((err) => {
                console.log(err);
            }).finally(() => {
                props.handleClose();
                setLoading(false);
            });
    };

    return (
        <Modal
            open={props.open}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 1000,
            }}
            style={{
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'center',
                marginTop: '1vh',
            }}
        >
            <Grow in={props.open}>
                <div
                    className="modal-xl modal-dialog"
                    tabIndex="-1"
                    id="export_modal_activa"
                    role="dialog"
                    aria-labelledby="myModalLabelActivaExport"
                >
                    <div className="modal-content">
                        <div className="modal-header bg-fleet">
                            <h4 className="modal-title text-white" id="myModalLabelActivaExport">
                                <i className="ft-download align-middle icon-modal-title"></i>
                                <FormattedMessage id="disponibilidadActiva.export_modal.header" defaultMessage=" Exportar Disponibilidad Activa" />
                            </h4>
                            <button type="button" onClick={props.handleClose} className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body modal-grey modal-mh ovf-x-hidden">
                            <div className="row">
                                <div className="col-md-12">
                                    <form className="form form-horizontal">
                                        <div className="form-body">
                                            <div className="card pull-up">
                                                <div className="card-content">
                                                    <div className="card-body">
                                                        <h4 className="form-section">
                                                            <i className="la la-columns"></i>
                                                            <FormattedMessage id="disponibilidadActiva.export_modal.columns_to_export" defaultMessage=" Columnas a exportar" />
                                                        </h4>
                                                        <Grid container item xs={12} spacing={3} style={{ marginBottom: 20 }}>
                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="dominio">
                                                                    <FormattedMessage id="disponibilidadActiva.col_dominio" defaultMessage="Dominio:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("dominio")}
                                                                    checked={dataToExport.dominio}
                                                                    id="dominio"
                                                                    name="dominio"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="motivo">
                                                                    <FormattedMessage id="disponibilidadActiva.col_motivo" defaultMessage="Motivo:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("motivo")}
                                                                    checked={dataToExport.motivo}
                                                                    id="motivo"
                                                                    name="motivo"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="fechaInicioOciosidad">
                                                                    <FormattedMessage id="disponibilidadActiva.export_modal.col_fecha_inicio" defaultMessage="Fecha Inicio Ociosidad:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("fechaInicioOciosidad")}
                                                                    checked={dataToExport.fechaInicioOciosidad}
                                                                    id="fechaInicioOciosidad"
                                                                    name="fechaInicioOciosidad"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="fechaEventoOciosidad">
                                                                    <FormattedMessage id="disponibilidadActiva.export_modal.col_fecha_procesamiento" defaultMessage="Fecha Procesamiento Ociosidad:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("fechaEventoOciosidad")}
                                                                    checked={dataToExport.fechaEventoOciosidad}
                                                                    id="fechaEventoOciosidad"
                                                                    name="fechaEventoOciosidad"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="fechaFinOciosidad">
                                                                    <FormattedMessage id="disponibilidadActiva.export_modal.col_fecha_fin" defaultMessage="Fecha Fin Ociosidad:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("fechaFinOciosidad")}
                                                                    checked={dataToExport.fechaFinOciosidad}
                                                                    id="fechaFinOciosidad"
                                                                    name="fechaFinOciosidad"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="fecha_actualizacion_motivo">
                                                                    <FormattedMessage id="disponibilidadActiva.export_modal.col_fecha_actualizacion_motivo" defaultMessage="Fecha Actualización Motivo:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("fecha_actualizacion_motivo")}
                                                                    checked={dataToExport.fecha_actualizacion_motivo}
                                                                    id="fecha_actualizacion_motivo"
                                                                    name="fecha_actualizacion_motivo"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="usuarioModificacionMotivo">
                                                                    <FormattedMessage id="disponibilidadActiva.export_modal.col_usuario_modificacion_motivo" defaultMessage="Usuario Modificación Motivo:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("usuarioModificacionMotivo")}
                                                                    checked={dataToExport.usuarioModificacionMotivo}
                                                                    id="usuarioModificacionMotivo"
                                                                    name="usuarioModificacionMotivo"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="modelo">
                                                                    <FormattedMessage id="disponibilidadActiva.col_modelo" defaultMessage="Modelo:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("modelo")}
                                                                    checked={dataToExport.modelo}
                                                                    id="modelo"
                                                                    name="modelo"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="tipo">
                                                                    <FormattedMessage id="disponibilidadActiva.col_tipo" defaultMessage="Tipo:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("tipo")}
                                                                    checked={dataToExport.tipo}
                                                                    id="tipo"
                                                                    name="tipo"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="base">
                                                                    <FormattedMessage id="disponibilidadActiva.col_base" defaultMessage="Base:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("base")}
                                                                    checked={dataToExport.base}
                                                                    id="base"
                                                                    name="base"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="subRegion">
                                                                    <FormattedMessage id="disponibilidadActiva.col_subRegion" defaultMessage="Sub Región:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("subRegion")}
                                                                    checked={dataToExport.subRegion}
                                                                    id="subRegion"
                                                                    name="subRegion"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="region">
                                                                    <FormattedMessage id="disponibilidadActiva.col_region" defaultMessage="Región:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("region")}
                                                                    checked={dataToExport.region}
                                                                    id="region"
                                                                    name="region"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>

                                                            {ConfigBusiness.get('moviles.transportadora.grilla') === 'true' && (
                                                                <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                    <label className="col-md-6 label-control col-form-label" htmlFor="transportadora">
                                                                        <FormattedMessage id="disponibilidadActiva.col_transportadora" defaultMessage="Transportadora:" />
                                                                    </label>
                                                                    <Switch
                                                                        onChange={() => handleDataExport("transportadora")}
                                                                        checked={dataToExport.transportadora}
                                                                        id="transportadora"
                                                                        name="transportadora"
                                                                        offColor="#FF4961"
                                                                        onColor="#28D094"
                                                                        className="col-md-6 align-middle"
                                                                    />
                                                                </Grid>
                                                            )}

                                                            {ConfigBusiness.get('frontend.rentadora.grilla') === 'true' && (
                                                                <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                    <label className="col-md-6 label-control col-form-label" htmlFor="rentadora">
                                                                        <FormattedMessage id="disponibilidadActiva.col_rentadora" defaultMessage="Rentadora:" />
                                                                    </label>
                                                                    <Switch
                                                                        onChange={() => handleDataExport("rentadora")}
                                                                        checked={dataToExport.rentadora}
                                                                        id="rentadora"
                                                                        name="rentadora"
                                                                        offColor="#FF4961"
                                                                        onColor="#28D094"
                                                                        className="col-md-6 align-middle"
                                                                    />
                                                                </Grid>
                                                            )}

                                                            <Grid component={Box} item xs={ITEM_XS} className="align-self-end">
                                                                <label className="col-md-6 label-control col-form-label" htmlFor="centroCostos">
                                                                    <FormattedMessage id="disponibilidadActiva.col_centroCostos" defaultMessage="Centro de Costos:" />
                                                                </label>
                                                                <Switch
                                                                    onChange={() => handleDataExport("centroCostos")}
                                                                    checked={dataToExport.centroCostos}
                                                                    id="centroCostos"
                                                                    name="centroCostos"
                                                                    offColor="#FF4961"
                                                                    onColor="#28D094"
                                                                    className="col-md-6 align-middle"
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-12 alert alert-info small" role="alert">
                                                <FormattedMessage id="disponibilidadGrid.render.export_modal.columns_export.information_esta_accion_puede_demorar_unos_minutos" defaultMessage="Esta acción puede demorar unos minutos." />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer modal-grey">
                            <button type="button" className="btn btn-default btn-fleet" onClick={handleExportExcel}>
                                <i className={loading ? 'la la-spinner spinner' : 'fa fa-download'}></i>
                                <FormattedMessage id="disponibilidadGrid.render.export_modal.finish_button.exportar_a_excel" defaultMessage=" Exportar a Excel" />
                            </button>
                            <button type="button" className="btn btn-danger" onClick={props.handleClose}>
                                <i className="fa fa-times-circle"></i>
                                <FormattedMessage id="disponibilidadGrid.render.export_modal.finish_button.cancelar" defaultMessage=" Cancelar" />
                            </button>
                        </div>
                    </div>
                </div>
            </Grow>
        </Modal>
    );
};

export default DisponibilidadActivaExport;
